import { render, staticRenderFns } from "./product_multiselect.vue?vue&type=template&id=2c08a93d&scoped=true"
import script from "./product_multiselect.vue?vue&type=script&lang=js"
export * from "./product_multiselect.vue?vue&type=script&lang=js"
import style0 from "./product_multiselect.vue?vue&type=style&index=0&id=2c08a93d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c08a93d",
  null
  
)

export default component.exports